import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ejemplo-loader',
  templateUrl: './ejemplo-loader.component.html',
  styleUrls: ['./ejemplo-loader.component.scss']
})
export class EjemploLoaderComponent implements OnInit {
  loader = false
  loaderIssys = false
  constructor() { }

  ngOnInit(): void {
  }
  load=(issys:boolean=false)=>{
    if(issys) this.loaderIssys=!this.loaderIssys;
    else this.loader = !this.loader
  }

}
